import React, { FC } from 'react';
import Loader from './Loader';
import ResultItem from './ResultItem';
import { PaginatedResults } from '../../../hooks/useGlobalSearch';
import { Box, TablePagination } from '@material-ui/core';
import { Fetchable } from 'src/interfaces/api/api';

interface Props {
  onPageChange: (page: number) => void;
  results: Fetchable<PaginatedResults>;
  hidden: boolean;
}
const ResultsSection: FC<Props> = ({ hidden, results, onPageChange }) => {
  if (hidden) {
    return null;
  }

  return results.status === 'fetching' ? (
    <Loader />
  ) : results.status === 'error' ? (
    <div>{results.error}</div>
  ) : (
    <div>
      {results.data.items.length === 0 && (
        <Box fontStyle='italic' marginLeft='20px'>
          Aucun résultat
        </Box>
      )}

      {results.data.items.map((item, key) => (
        <ResultItem key={key} label={item.text} link={item.link} />
      ))}

      <TablePagination
        rowsPerPageOptions={[25]}
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} sur ${count}`}
        labelRowsPerPage='Element par page: '
        component='div'
        count={results.data.total}
        rowsPerPage={25}
        page={results.data.page}
        onPageChange={(e, page) => onPageChange(page)}
      />
    </div>
  );
};

export default ResultsSection;
